import React from 'react';
import { Select, Space } from 'antd';
import { allowedGranularities, GranularityMap } from '@components/common/GranularitySelect/utils';
import { useAtom, useAtomValue } from 'jotai';
import { granularityAtom, intervalAtom } from '@src/components/usage-dashboard/atoms';
import { GRANULARITY } from '@utils/granularity';
import { StyledGranularity } from '../styled';

const GranularityPicker = () => {
  const [granularity, setGranularity] = useAtom(granularityAtom);
  const interval = useAtomValue<Date[]>(intervalAtom);

  const allowedGran = allowedGranularities({ from: interval[0], to: interval[1] });
  let defaultValue;
  const options = Object.values(GranularityMap).filter((option) => {
    if (option.value === granularity) {
      defaultValue = option;
    }
    if (option.value === GRANULARITY.PT10S) return false;
    return allowedGran.includes(option.value);
  });

  return (
    <Space>
      <StyledGranularity>Granularity:</StyledGranularity>
      <Select
        defaultValue={defaultValue}
        onChange={setGranularity}
        style={{ width: 100 }}
        options={options}
        value={defaultValue}
      />
    </Space>
  );
};

export default GranularityPicker;
